export const THEME_GRID_SPACING = 3;
export const THEME_DRAWER_WIDTH = 260;
export const THEME_HEADER_HEIGHT = 80;
